import { createModel } from '@rematch/core';
import { PaginationType, PoiConfigurationType, RootModel } from '@types';
import { PoiConfigurationService } from '@services';
import baseEntity from './base.entity';
import { Dispatch } from '@redux/store';

interface PoiConfigurationStateType {
  ids: { [id: number]: PoiConfigurationType };
}

export const poiConfigurationEntities = createModel<RootModel>()({
  state: { ids: {} } as PoiConfigurationStateType,
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: Dispatch) => ({
    async load(payload): Promise<{ content: PoiConfigurationType[] } & PaginationType> {
      const res = await PoiConfigurationService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state): Promise<PoiConfigurationType> {
      const item = state.poiConfigurationEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await PoiConfigurationService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await PoiConfigurationService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await PoiConfigurationService.create(payload));
      } else {
        ({ data: item } = await PoiConfigurationService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    }
  }),
});
